var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmailFancy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "email_image",
    "data-name": "email image",
    transform: "translate(-134.473 -238.813)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_",
    "data-name": "<Group>",
    transform: "translate(124.831 87.332)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38724",
    "data-name": "Group 38724",
    transform: "translate(24.644 166.23)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1234",
    "data-name": "Ellipse 1234",
    cx: 50,
    cy: 50,
    r: 50,
    transform: "translate(-15.002 -14.75)",
    fill: "#39be9d",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1154",
    "data-name": "Ellipse 1154",
    cx: 35,
    cy: 35,
    r: 35,
    transform: "translate(-0.002 0.25)",
    fill: "#39be9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "envelope_2_",
    "data-name": "envelope (2)",
    d: "M3,59.882H29a3,3,0,0,1,3,3v18a3,3,0,0,1-3,3H3a3,3,0,0,1-3-3v-18A3,3,0,0,1,3,59.882Zm0,2a.994.994,0,0,0-.383.077L16,73.559l13.383-11.6A1,1,0,0,0,29,61.882Zm0,20H29a1,1,0,0,0,1-1V64.072L16.655,75.638a1,1,0,0,1-1.311,0L2,64.072v16.81A1,1,0,0,0,3,81.882Z",
    transform: "translate(19.498 -36.132)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.1
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailFancy);
export default __webpack_public_path__ + "static/media/email-fancy.ba6795813c3d4db2c38714ce19853395.svg";
export { ForwardRef as ReactComponent };